export default __webpack_public_path__ + "static/media/23.2243e452.jpg";